/* @flow */
import * as React from 'react';
import cx from 'classnames';

import Button from 'components/Button';
import Glyph from 'components/Glyph';
import Group from 'entities/Group';
import GroupSelectToInviteDialog from 'groups/components/GroupSelectToInviteDialog';
import ModalTrigger from 'components/ModalTrigger';
import TooltipTrigger from 'components/TooltipTrigger';
import UsersInviteModal from 'users/components/UsersInviteModal';

import './styles/InviteButton.scss';

type Props = {
  group: Group,
  forceType?: 'button' | 'glyph',
  className?: string,
};
class InviteButton extends React.Component<Props> {
  canInvite = () => {
    const { group } = this.props;
    return group.isRoot() || group.canAddPeople();
  };

  renderModal = () => {
    const { group } = this.props;

    if (group.isRoot()) {
      return <GroupSelectToInviteDialog />;
    }

    return <UsersInviteModal group={group} />;
  };

  renderButton = (className: string, text: string) => {
    return (
      <Button
        size="small"
        eventElementName="add_people"
        data-test-selector="invite_button"
        {...this.props}
        className={cx(this.props.className, className)}>
        {text}
      </Button>
    );
  };

  renderGlyph = (className: string, text: string) => {
    return (
      <TooltipTrigger tooltip={text} placement="bottom">
        <Button
          {...this.props}
          aria-label="Add people"
          eventElementName="add_people"
          full={false}
          size="small"
          level="icon"
          className={className}
          data-test-selector="invite_button">
          <Glyph name="avatar-add" size="large" color="brand" solo />
        </Button>
      </TooltipTrigger>
    );
  };

  render() {
    if (!this.canInvite()) {
      return null;
    }

    const text = 'Add people';
    let trigger;

    if (this.props.forceType === 'button') {
      trigger = <span>{this.renderButton('InviteButton-alwaysButton', text)}</span>;
    } else if (this.props.forceType === 'glyph') {
      trigger = <span>{this.renderGlyph('InviteButton-alwaysGlyph', text)}</span>;
    } else {
      trigger = (
        <span>
          {this.renderGlyph('InviteButton-small', text)}
          {this.renderButton('InviteButton-big', text)}
        </span>
      );
    }

    return (
      <ModalTrigger modal={this.renderModal()} className="InviteButton">
        {trigger}
      </ModalTrigger>
    );
  }
}

export default InviteButton;
